import React from "react";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import styles from "./DeleteButton.css";

const { t } = new Translate();

const DeleteButton = ({ confirmMessage, label, onClick }) => {
  const confirmClick = () => {
    if (confirmMessage) {
      if (confirm(confirmMessage)) return onClick(); // eslint-disable-line

      return null;
    }

    return onClick();
  };

  return (
    <button className={styles.root} onClick={confirmClick} type="button">
      {label}
    </button>
  );
};

DeleteButton.propTypes = {
  confirmMessage: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

DeleteButton.defaultProps = {
  label: t("delete"),
};

export default DeleteButton;
